<template>
  <div class="drift-velocity-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>I = nqvS | v_d = I / (nqS)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 500 240">
          <!-- Conductor (Wire section) -->
          <rect x="50" y="80" width="400" height="80" rx="10" fill="rgba(255,255,255,0.02)" stroke="#555" stroke-width="2" />
          
          <!-- Crystal Lattice (Fixed Cations) -->
          <g v-for="x in latticeX" :key="'lx'+x">
            <g v-for="y in [100, 140]" :key="'ly'+y">
               <circle :cx="x" :cy="y" r="6" fill="rgba(255, 71, 87, 0.4)" />
               <text :x="x-3" :y="y+4" fill="#fff" font-size="10">+</text>
            </g>
          </g>

          <!-- Free Electrons -->
          <g v-for="(e, i) in electrons" :key="'e'+i">
            <!-- Random Thermal Path (Optional tail) -->
            <circle :cx="e.displayX" :cy="e.displayY" r="3" fill="#00d2ff" shadow="0 0 5px #00d2ff">
               <animateMotion 
                 v-if="playing"
                 :dur="driftDur + 's'" 
                 repeatCount="indefinite"
                 :path="`M 0 0 L ${400} 0`"
                 :begin="e.delay + 's'"
               />
            </circle>
          </g>

          <!-- Electric Field Lines -->
          <g v-if="voltage > 0">
             <line x1="60" y1="120" x2="440" y2="120" stroke="rgba(255,255,255,0.1)" marker-end="url(#efield)" />
             <text x="450" y="125" fill="rgba(255,255,255,0.3)" font-size="10">E</text>
          </g>

          <defs>
             <marker id="efield" markerWidth="6" markerHeight="4" refX="6" refY="2" orient="auto">
                <polygon points="0 0, 6 2, 0 4" fill="rgba(255,255,255,0.3)" />
             </marker>
          </defs>
        </svg>

        <div class="hud-top">
          <div class="stat">
            <label>漂移速度 v_d:</label>
            <div class="value">{{ driftVelocity.toFixed(4) }} m/s</div>
          </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <div class="flex-1">
               <label>叠加电压 (改变电场强度 E)</label>
               <el-slider v-model="voltage" :min="0" :max="100" size="mini"></el-slider>
             </div>
             <div class="flex-1">
               <label>导体截面积 (S)</label>
               <el-slider v-model="area" :min="10" :max="50" size="mini"></el-slider>
             </div>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>微观原理：</strong>导体内部的自由电子在做无规则热运动。施加电压后，电子在无规则运动的基础上叠加了一个<strong>定向移动</strong>（漂移）。
           虽然电场传播接近光速，但电子实际的漂移速度极其缓慢（通常仅为 10⁻⁴ m/s）。电流的大小取决于单位体积内的电荷密度、电荷量、截面积以及这个<strong>漂移速度</strong>。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElectronDriftViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      voltage: 30,
      area: 25,
      playing: true,
      electrons: Array.from({length: 25}, () => ({
        displayX: 50 + Math.random() * 400,
        displayY: 90 + Math.random() * 60,
        delay: -Math.random() * 10
      })),
      latticeX: [100, 150, 200, 250, 300, 350, 400]
    }
  },
  computed: {
    driftVelocity() { return (this.voltage / this.area) * 0.005; },
    driftDur() { return 10 / (this.driftVelocity + 0.001); }
  }
}
</script>

<style scoped lang="scss">
.drift-velocity-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
.row { display: flex; gap: 20px; align-items: center; }
label { font-size: 0.75rem; color: #888; margin-bottom: 5px; display: block; }
.flex-1 { flex: 1; }
</style>
